import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
type RemoveOrgMemberProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const RemoveOrgMember = t0 => {
  const $ = _c(25);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.remove"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  const {
    data: t2
  } = useSession();
  const {
    org
  } = t2;
  if (detail.kind !== "remove_org_member") {
    return null;
  }
  const {
    firstName,
    lastName
  } = detail.data.member;
  let t3;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t3 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="text-body-2 text-tertiary">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== firstName || $[7] !== lastName || $[8] !== t) {
    t5 = firstName && lastName ? `${firstName} ${lastName}` : t(_temp3);
    $[6] = firstName;
    $[7] = lastName;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="text-label-2 text-primary">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t(_temp4);
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = ` ${t7} `;
  let t9;
  if ($[14] !== t8) {
    t9 = <span className="text-body-2 text-tertiary">{t8}</span>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t(_temp5);
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = ` ${org?.name} ${t10}`;
  let t12;
  if ($[18] !== t11) {
    t12 = <span className="text-label-2 text-primary">{t11}</span>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t4 || $[22] !== t6 || $[23] !== t9) {
    t13 = <>{t4}{t6}{t9}{t12}</>;
    $[20] = t12;
    $[21] = t4;
    $[22] = t6;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export default RemoveOrgMember;
function _temp($) {
  return $.removed;
}
function _temp2($_0) {
  return $_0.removed;
}
function _temp3($_1) {
  return $_1.aMember;
}
function _temp4($_2) {
  return $_2.from;
}
function _temp5($_3) {
  return $_3.team;
}